var _rect, _line, _line2, _line3, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRules(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 12,
    height: 16,
    rx: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 8,
    x2: 14,
    y2: 8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 11,
    x2: 12,
    y2: 11
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 14,
    x2: 13,
    y2: 14
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "15,16 17,18 20,14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRules);
export default __webpack_public_path__ + "static/media/rules.5a9b8022de2935ff8704d87c1cb3adf0.svg";
export { ForwardRef as ReactComponent };